// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"45e3280f","213":"d85cfadc","455":"023cb25f"}[chunkId] + ".chunk.js";
};